export const headerTestId = {
  anchor: 'header_anchorLink',
  link: 'header_routeLink',
  menu: 'header_mobileMenu',
  logo: 'header_logo',
  menuButton: 'header_menuButton',
};
